/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';

/** ReadUsersOpportunitiesSearchRequest — dark-roast DTO: UserOpportunitiesSearchRequestDto */
export const readUsersOpportunitiesSearchRequestSchema = z.object({ "assigneeType": z.string(), "isFulfillmentActive": z.boolean().nullish(), "isSubmitted": z.boolean().nullish(), "order": z.enum(["asc", "desc"]), "page": z.number(), "pageSize": z.number(), "search": z.string().nullish(), "sort": z.string(), "stageCode": z.array(z.string()) });
export type ReadUsersOpportunitiesSearchRequest = z.infer<typeof readUsersOpportunitiesSearchRequestSchema>;
